import { render, staticRenderFns } from "./attendeeForm.vue?vue&type=template&id=22d4259d&"
import script from "./attendeeForm.vue?vue&type=script&lang=js&"
export * from "./attendeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports